import { Gender } from '~~/openapi-client/gen/schemas'

export const genderOptions: Gender[] = Object.values(Gender)

export const getGenderLabel = (gender: Gender) => {
	switch (gender) {
		case Gender.MALE: return 'Männlich'
		case Gender.FEMALE: return 'Weiblich'
		case Gender.DIVERSE: return 'Divers'
		case Gender.NOT_SPECIFIED: return 'Keine Angabe'
	}
}
